import { createGlobalStyle } from 'styled-components'

import { fontsFaces } from './fonts'

export const GlobalStyles = createGlobalStyle`
  ${fontsFaces()}
  * {
    box-sizing: border-box;
    &:before, &:after {
      box-sizing: border-box;
    }
  }
  html {
    font-size: 62.5%;
  }
  body {
    padding: 0;
    margin: 0;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
  }  
  p {
    margin: 0;
    padding: 0;
  }
  a {
    text-decoration: none;
    cursor: pointer;
    &:hover {
      text-decoration: none;
    }
  }
  img {
    max-width: 100%;
    height: auto;
    vertical-align: middle
  }
  button {
    padding: 0;
    border: 0;
  }  
  input, select, textarea, button {
    &:focus:not([keyboard-focus]) {
      outline-width: 0;
    }
  }  
  input::-ms-clear {
    display: none;
  }
`
